import type { RefObject } from "react";
import {
  queryOnboardingWelcomeTargets,
  runOnboardingWelcomeEntrance,
  type OnboardingWelcomeGsapTimeline,
} from "./runOnboardingWelcomeEntrance";

const LAYOUT_RETRY_MS = 48;
const LAYOUT_MAX_ATTEMPTS = 8;

/**
 * iOS WKWebView：Modal 首帧常尚未完成布局，query 不到 wave-chunk 会导致全程 opacity:0。
 */
export const scheduleOnboardingWelcomeEntrance = (
  containerRef: RefObject<HTMLElement | null>,
  ctaRef: RefObject<HTMLButtonElement | null>,
  targetCount: number,
  onTimeline: (timeline: OnboardingWelcomeGsapTimeline) => void,
): (() => void) => {
  let cancelled = false;
  let attempt = 0;
  let raf = 0;
  let retryTimer = 0;

  const tryStart = () => {
    if (cancelled) {
      return;
    }

    const root = containerRef.current;
    if (!root) {
      scheduleRetry();
      return;
    }

    const targets = queryOnboardingWelcomeTargets(root, ctaRef.current);
    const hasWave = targets.waveChunks.length > 0;

    if (!hasWave && attempt < LAYOUT_MAX_ATTEMPTS) {
      scheduleRetry();
      return;
    }

    onTimeline(runOnboardingWelcomeEntrance(root, ctaRef.current, targetCount));
  };

  const scheduleRetry = () => {
    attempt += 1;
    retryTimer = window.setTimeout(() => {
      raf = requestAnimationFrame(tryStart);
    }, LAYOUT_RETRY_MS);
  };

  raf = requestAnimationFrame(() => {
    raf = requestAnimationFrame(tryStart);
  });

  return () => {
    cancelled = true;
    cancelAnimationFrame(raf);
    window.clearTimeout(retryTimer);
  };
};
